import React from 'react'
import {Icon, Tooltip} from "antd"
import * as PropTypes from "prop-types";

const TooltipIcon = props => <Tooltip {...props.tooltipProps} title={props.title || ''}>
  <Icon style={props.iconStyle || {}} type={props.type || ''} theme={props.theme || ''}/>
</Tooltip>;

TooltipIcon.propTypes = {
  title: PropTypes.node || PropTypes.string,
  type: PropTypes.string,
  theme: PropTypes.string,
  tooltipProps: PropTypes.object,
  iconStyle: PropTypes.object,
};

export default TooltipIcon


// WEBPACK FOOTER //
// ./src/components/Boilerplate/TooltipIcon.js